export enum StatsFilters {
  START_DATE = "startDate",
  END_DATE = "endDate",
}
export enum DateFilterTypes {
  LAST_30_DAYS = "last30Days",
  LAST_14_DAYS = "last14Days",
  LAST_7_DAYS = "last7Days",
  PREVIOUS_MONTH = "previousMonth",
  LAST_90_DAYS = "last90Days",
  CUSTOM = "custom",
}

export interface statsState {
  devicesPerDayList: { day: string; count: number }[];
  subscribedAndReachedPerEventList: {
    eventId: string;
    eventTitle: string;
    devicesSubscribedCount: number;
    devicesReachedCount: number;
    created: Date;
  }[];
  devicesInfo: {
    os: { android: number; ios: number };
    manufacturer: {
      [key: string]: number;
    };
    androidVersion: {
      [key: string]: number;
    };
    iOSVersion: {
      [key: string]: number;
    };
  };
  filters: {
    [statsFilter in StatsFilters]?: string | number;
  };
  dateFilterType: DateFilterTypes;
}

export type SetStatsFiltersAction = {
  payload: {
    statsFilter?: StatsFilters;
    value: string | number;
  };
};
export type SetStatsDateFilterType = {
  payload: {
    dateFilterType: DateFilterTypes;
    startDate?: string;
    endDate?: string;
  };
};
export type TriggerDevicesSubscribedAndReachedRequestAction = {
  payload: {
    merchantId: string;
  };
};
